import { FC } from 'react';
import { Text, Flex } from '@chakra-ui/react';
import { resolveFields } from '../Fields';
import { Post } from '../../types';
import ArticleContainer from '../ArticleContainer';
import Breadcrumb from '../Breadcrumb';
import Heading from '../Heading';
import { BlockRenderer } from '../Fields/BlockRenderer';

const ListingTemplate: FC<Post> = ({
  post_title,
  post_excerpt,
  fields,
  children,
}) => {
  const [hero, contentFields] = resolveFields(fields);

  const { title = post_title, leadText = post_excerpt } = hero
    ? {
        title: hero.heading?.title || post_title,
        leadText: hero.text || post_excerpt,
      }
    : {};

  return (
    <ArticleContainer>
      <Breadcrumb />
      <Flex
        as="header"
        flexWrap={['wrap', 'wrap', 'wrap', 'nowrap']}
        py={[null, 3]}
        gridColumnGap="5"
      >
        <Heading
          as="h1"
          sx={{ ':not(:only-child)': { mb: 5 } }}
          flex={['0 0 100%', '0 0 100%', '0 0 100%', '0 0 33.3333%']}
        >
          {title}
        </Heading>
        {leadText && <Text textStyle="xl">{leadText}</Text>}
      </Flex>
      {children}
      <BlockRenderer blocks={contentFields} />
    </ArticleContainer>
  );
};

export default ListingTemplate;
